module.exports = __webpack_public_path__ + "static/media/h_blog2.7828a1a1.jpg";